import {
    GET_ALL_USER_DEPARTMENT_REQUEST, GET_ALL_USER_DEPARTMENT_ERROR, GET_ALL_USER_DEPARTMENT_SUCCESS,
    ADD_ADMIN_DEPARTMENT_REQUEST, ADD_ADMIN_DEPARTMENT_ERROR, ADD_ADMIN_DEPARTMENT_SUCCESS,
    UPDATE_ADMIN_DEPARTMENT_REQUEST, UPDATE_ADMIN_DEPARTMENT_ERROR, UPDATE_ADMIN_DEPARTMENT_SUCCESS,
    DELETE_ADMIN_DEPARTMENT_REQUEST, DELETE_ADMIN_DEPARTMENT_ERROR, DELETE_ADMIN_DEPARTMENT_SUCCESS,
} from "./types";
import { BASEURL } from "../../constant/config.js"
import axios from "axios";


export const getAllUserDepartment = (token, userId, data) => dispatch => {

    dispatch({ type: GET_ALL_USER_DEPARTMENT_REQUEST })
    return axios({
        method: "POST",
        url: `${BASEURL}getAll/UserDepartment`,

        headers: {
            Accept: "application/json",
            'Authorization': 'Bearer ' + token
        },
    })
        .then(response => {
            return dispatch({ type: GET_ALL_USER_DEPARTMENT_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            return dispatch({
                type: GET_ALL_USER_DEPARTMENT_ERROR,
                payload: error.response,
            });
        })

}

export const addAdminDepartment = (token, data, menu_id) => (dispatch) => {
    dispatch({ type: ADD_ADMIN_DEPARTMENT_REQUEST });
    return axios({
        method: "POST",
        url: `${BASEURL}create/UserDepartment`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
        data: { department_name: data.adminDepartmentName, is_active: data.check, menu_id },
    })
        .then((response) => {
            return dispatch({ type: ADD_ADMIN_DEPARTMENT_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            return dispatch({
                type: ADD_ADMIN_DEPARTMENT_ERROR,
                payload: error.response,
            });
        });
};

export const updateAdminDepartment = (token, data, id) => (dispatch) => {
    dispatch({ type: UPDATE_ADMIN_DEPARTMENT_REQUEST });
    return axios({
        method: "PUT",
        url: `${BASEURL}update/UserDepartment/${id}`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
        data: { department_name: data.adminDepartmentName, is_active: data.check },
    })
        .then((response) => {
            return dispatch({ type: UPDATE_ADMIN_DEPARTMENT_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            return dispatch({
                type: UPDATE_ADMIN_DEPARTMENT_ERROR,
                payload: error.response,
            });
        });
};

export const deleteAdminDepartment = (token, id) => (dispatch) => {
    dispatch({ type: DELETE_ADMIN_DEPARTMENT_REQUEST });
    return axios({
        method: "DELETE",
        url: `${BASEURL}delete/UserDepartment/${id}`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
    })
        .then((response) => {
            return dispatch({ type: DELETE_ADMIN_DEPARTMENT_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            return dispatch({
                type: DELETE_ADMIN_DEPARTMENT_ERROR,
                payload: error.response,
            });
        });
};